import { createAction, props } from '@ngrx/store';
import { Todo } from '../../models/todo';

export const createOne = createAction('[Todo API] Create One', props<{ todo: Todo }>());
export const createOneSucccess = createAction('[Todo API] Create One Success', props<{ todo: Todo }>());

export const editOne = createAction('[Todo API] Update One', props<{ todo: Todo }>());
export const editOneSuccess = createAction('[Todo API] Update One Success', props<{ todo: Todo }>());

export const deleteOne = createAction('[Todo API] Delete One', props<{ todo: Todo }>());
export const deleteOneSucccess = createAction('[Todo API] Delete One Success', props<{ todo: Todo }>());

export const loadTodosFromPage = createAction('[Todo API] Get All Todos');
export const getAllSuccess = createAction('[Todo API] Get All Todos Succees', props<{ todoList: Todo[] }>());
